export const makeApiUrl = (route: string) => `${process.env.API_URL}/${route}`;
